import { render } from "./VideoProduct.vue?vue&type=template&id=374ad431"
import script from "./VideoProduct.vue?vue&type=script&lang=js"
export * from "./VideoProduct.vue?vue&type=script&lang=js"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__